export default function Checkbox({ className = '', ...props }) {
    return (
        <input
            {...props}
            type="checkbox"
            className={
                'rounded border-gray-300 text-primary-blue-500 shadow-sm focus:ring-primary-blue-500 ' +
                className
            }
        />
    );
}
